import { atom, useRecoilValue } from "recoil"
import { HomePageConfigItemType } from "./homePageSupport"

export const segmentOrderDefault = {
    "Preferiti": 1,
    "Link": 2,
    "History": 3,
    "News": 4,
    "NotaOperativa": 5,
    "Drop": 6,
}

export type SegmentsPropsType = Record<SegmentOrderKeyType, HomePageConfigItemType>

export type SegmentOrderType = typeof segmentOrderDefault
export type SegmentOrderKeyType = keyof SegmentOrderType

// Il seguente atom si è reso necessario per obbligare l'interfaccia a fare il refresh
// quando si cambia l'ordine delle sezioni (senza non sempre faceva il refresh pur mutando i dati)
export const keyHomePageSegmentsHandler = atom({
    key: 'keyHomePageSegmentsHandler',
    default: 0,
})

export const useKeyPageSegmentHandler = () => useRecoilValue(keyHomePageSegmentsHandler)

